import { render, staticRenderFns } from "./recruitment.vue?vue&type=template&id=df353b3c&scoped=true"
import script from "./recruitment.vue?vue&type=script&lang=ts"
export * from "./recruitment.vue?vue&type=script&lang=ts"
import style0 from "./recruitment.vue?vue&type=style&index=0&id=df353b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df353b3c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonSectionTitle: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/common/section-title.vue').default,CommonWrapSection: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/common/wrap-section.vue').default})
